import { withInstall } from '../utils/index';
import Markdown from './viewer.vue';
import './github.less';
import './article.less';

export const TlbsMarkdown = withInstall(Markdown);
export default TlbsMarkdown;
